
(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('wpHostedPayment', function($window) {
    return {
        restrict: 'E',
        scope: {
            challengeUrl: '='
        },
        template: '<div data-iframe="true" id="hosted-payment-fields"></div>',
        link(scope) {

            function loadScript(src) {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = src;
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                });
            }
             scope.$on('wpHostedPaymentInit', function(ev, threedsData) {
                loadScript('https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js').then(() => {
                    const customOptions = {
                        url: `${decodeURI(threedsData.AcsUrl)}`,
                        type: 'iframe',
                        inject: 'immediate',
                        target: 'hosted-payment-fields',
                        accessibility: true,
                        debug: false,
                        language: 'en',
                        country: 'gb',
                        preferredPaymentMethod: 'VISA-SSL',
                        resultCallback: response => {
                            scope.$emit('WPHostedResponseHandler', { response, prepaymentid: `${threedsData.PrePaymentID}` });
                        }
                    };
                    //initialise the library and pass options
                    if (typeof $window.WPCL !== 'undefined') {
                        const libraryObject = new $window.WPCL.Library();
                        libraryObject.setup(customOptions);
                    }
                    })
                    .catch(err => {
                        console.error('Failed to load third-party script:', err);
                    });

            });
        }
    };
});
})();
